import { defineComponent } from 'vue'
import type Node from '@element-plus/components/cascader-panel/src/node'
import type { RenderLabel } from '@element-plus/components/cascader-panel/src/types'
import type { PropType } from 'vue'

export default defineComponent({
  props: {
    node: {
      type: Object as PropType<Node>,
      required: true,
    },
    renderLabel: {
      type: Function as PropType<RenderLabel>,
      required: false,
    },
  },
  setup(props) {
    return () => {
      return props.renderLabel ? (
        <>{props.renderLabel({ node: props.node, data: props.node.data })}</>
      ) : (
        <span>{props.node.text}</span>
      )
    }
  },
})
